import { render, staticRenderFns } from "./iframeQuickSight.vue?vue&type=template&id=42b90964&scoped=true&"
import script from "./iframeQuickSight.vue?vue&type=script&lang=js&"
export * from "./iframeQuickSight.vue?vue&type=script&lang=js&"
import style0 from "./iframeQuickSight.vue?vue&type=style&index=0&id=42b90964&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b90964",
  null
  
)

export default component.exports